module.exports = __webpack_public_path__ + "img/muros_con_acabado_pulido.e4e08a8b.png";